export default __webpack_public_path__ + "static/media/mail-icon-blue.61c54687.svg";